import { render } from "./presenter.vue?vue&type=template&id=79954484&scoped=true"
import script from "./presenter.vue?vue&type=script&lang=js"
export * from "./presenter.vue?vue&type=script&lang=js"

import "./presenter.vue?vue&type=style&index=0&id=79954484&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79954484"

export default script